import { LAYOUTS, POSITION } from '@voltmoney/types';
import { ROUTE } from '../../../routes';
import { BorderRadiusTokens, ColorTokens, FontFamilyTokens, FontSizeTokens, LottieSizeTokens, LottieTokens, SizeTypeTokens, StackAlignContent, StackAlignItems, StackJustifyContent, StackPositionType, StackSelfContent, StackType, StackWidth, TextAlignTokens, WIDGET } from "@voltmoney/schema";
import { ACTION } from "./types";
import { failedVerification, initAction, successVerification } from "./actions";
import SharedPropsService from "../../../SharedPropsService";
export const template = async (isFromTata) => {
    return {
        layout: {
            id: ROUTE.DIGIO_AGREEMENT_INPROGRESS,
            type: LAYOUTS.LIST,
            widgets: [
                { id: "mainContainerStack", type: WIDGET.STACK },
                { id: "needAccessLinkStack", type: WIDGET.STACK, position: POSITION.ABSOLUTE_BOTTOM },
            ],
        },
        datastore: {
            mainContainerStack: {
                type: StackType.column,
                justifyContent: StackJustifyContent.center,
                padding: {
                    horizontal: SizeTypeTokens.XXXL
                },
                width: StackWidth.MATCH_PARENT,
                widgetItems: [
                    { id: "space80", type: WIDGET.SPACE },
                    { id: "space42", type: WIDGET.SPACE },
                    { id: "lottieStack", type: WIDGET.STACK },
                    { id: "spaceXL", type: WIDGET.SPACE },
                    { id: "headerText", type: WIDGET.TEXT },
                    { id: "space32", type: WIDGET.SPACE },
                    { id: "pointer1Stack", type: WIDGET.STACK },
                    { id: "spaceXL", type: WIDGET.SPACE },
                    { id: "pointer2Stack", type: WIDGET.STACK },
                    { id: "spaceXL", type: WIDGET.SPACE },
                    { id: "pointer3Stack", type: WIDGET.STACK },
                ]
            },
            headerText: {
                label: isFromTata ? "Redirecting you to agreement page" : 'Waiting for agreement completion',
                fontSize: FontSizeTokens.MD,
                fontFamily: FontFamilyTokens.Poppins,
                fontWeight: '600',
                lineHeight: 24
            },
            space80: {
                size: SizeTypeTokens.Size80
            },
            space42: {
                size: SizeTypeTokens.SIZE42
            },
            space32: {
                size: SizeTypeTokens.Size32
            },
            spaceXL: {
                size: SizeTypeTokens.XL
            },
            pointer1Stack: {
                type: StackType.row,
                width: StackWidth.MATCH_PARENT,
                widgetItems: [
                    { id: "pointer1Index", type: WIDGET.STACK },
                    { id: "spaceXL", type: WIDGET.SPACE },
                    { id: "pointer1Text", type: WIDGET.TEXT }
                ]
            },
            pointer2Stack: {
                type: StackType.row,
                width: StackWidth.MATCH_PARENT,
                widgetItems: [
                    { id: "pointer2Index", type: WIDGET.STACK },
                    { id: "spaceXL", type: WIDGET.SPACE },
                    { id: "pointer2Text", type: WIDGET.TEXT }
                ]
            },
            pointer3Stack: {
                type: StackType.row,
                width: StackWidth.MATCH_PARENT,
                widgetItems: [
                    { id: "pointer3Index", type: WIDGET.STACK },
                    { id: "spaceXL", type: WIDGET.SPACE },
                    { id: "pointer3Text", type: WIDGET.TEXT }
                ]
            },
            pointer1Text: {
                label: 'You will be redirected to the agreement page',
                fontSize: FontSizeTokens.SM,
                fontWeight: '500',
                lineHeight: 20,
                fontFamily: FontFamilyTokens.Inter
            },
            pointer2Text: {
                label: 'Verify & confirm usage terms & charges',
                fontSize: FontSizeTokens.SM,
                fontWeight: '500',
                lineHeight: 20,
                fontFamily: FontFamilyTokens.Inter
            },
            pointer3Text: {
                label: 'You will be redirected back to continue',
                fontSize: FontSizeTokens.SM,
                fontWeight: '500',
                lineHeight: 20,
                fontFamily: FontFamilyTokens.Inter
            },
            pointer1Index: {
                type: StackType.row,
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR6
                },
                maxWidth: 24,
                maxHeight: 24,
                width: StackWidth.CONTENT,
                justifyContent: StackJustifyContent.center,
                alignContent: StackAlignContent.center,
                alignItems: StackAlignItems.center,
                alignSelf: StackSelfContent.center,
                bgColor: ColorTokens.Grey_Chalk,
                padding: {
                    all: SizeTypeTokens.MD
                },
                widgetItems: [
                    { id: "pointer1IndexNumberText", type: WIDGET.TEXT }
                ]
            },
            pointer2Index: {
                type: StackType.row,
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR6
                },
                maxWidth: 24,
                maxHeight: 24,
                width: StackWidth.CONTENT,
                justifyContent: StackJustifyContent.center,
                alignContent: StackAlignContent.center,
                alignItems: StackAlignItems.center,
                alignSelf: StackSelfContent.center,
                bgColor: ColorTokens.Grey_Chalk,
                padding: {
                    all: SizeTypeTokens.MD
                },
                widgetItems: [
                    { id: "pointer2IndexNumberText", type: WIDGET.TEXT }
                ]
            },
            pointer3Index: {
                type: StackType.row,
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR6
                },
                maxWidth: 24,
                maxHeight: 24,
                width: StackWidth.CONTENT,
                justifyContent: StackJustifyContent.center,
                alignContent: StackAlignContent.center,
                alignItems: StackAlignItems.center,
                alignSelf: StackSelfContent.center,
                bgColor: ColorTokens.Grey_Chalk,
                padding: {
                    all: SizeTypeTokens.MD
                },
                widgetItems: [
                    { id: "pointer3IndexNumberText", type: WIDGET.TEXT }
                ]
            },
            pointer1IndexNumberText: {
                label: '1',
                fontSize: FontSizeTokens.SM,
                fontWeight: '500',
                lineHeight: 20,
                fontFamily: FontFamilyTokens.Inter
            },
            pointer2IndexNumberText: {
                label: '2',
                fontSize: FontSizeTokens.SM,
                fontWeight: '500',
                lineHeight: 20,
                fontFamily: FontFamilyTokens.Inter
            },
            pointer3IndexNumberText: {
                label: '3',
                fontSize: FontSizeTokens.SM,
                fontWeight: '500',
                lineHeight: 20,
                fontFamily: FontFamilyTokens.Inter
            },
            needAccessLinkStack: {
                type: StackType.row,
                width: StackWidth.CONTENT,
                position: StackPositionType.absolute,
                justifyContent: StackJustifyContent.center,
                positionConfig: {
                    bottom: SizeTypeTokens.NONE
                },
                widgetItems: [
                // { id: "needAccessText", type: WIDGET.TEXT },
                // { id: "needAccessLink", type: WIDGET.TEXT }
                ],
                action: {
                    type: ACTION.CALL_DIGIO_AGAIN,
                    routeId: ROUTE.DIGIO_AGREEMENT_INPROGRESS,
                    payload: {
                        delay: 0
                    }
                },
            },
            lottieStack: {
                type: StackType.column,
                width: StackWidth.MATCH_PARENT,
                alignItems: StackAlignItems.center,
                alignSelf: StackSelfContent.center,
                alignContent: StackAlignContent.center,
                widgetItems: [
                    { id: "lottie", type: WIDGET.LOTTIE }
                ]
            },
            lottie: {
                uri: LottieTokens.SandTimer,
                size: LottieSizeTokens.XXL,
                autoplay: true,
                loop: true,
            },
            needAccessText: {
                label: 'Agreement not completed?',
                fontSize: FontSizeTokens.MD,
                fontWeight: '400',
                lineHeight: 24,
                fontFamily: FontFamilyTokens.Inter,
                textAlign: TextAlignTokens.center
            },
            needAccessLink: {
                label: ' Click here',
                color: ColorTokens.Primary_100,
                lineHeight: 24,
                fontSize: FontSizeTokens.MD,
                fontFamily: FontFamilyTokens.Inter,
            },
        },
    };
};
export const digioAgreementInProgress = {
    onLoad: async ({}, { stepResponseObject }) => {
        const userData = await SharedPropsService.getUser();
        const isFromTata = userData.linkedApplications[0].lenderAccountId === "Tata";
        return Promise.resolve(template(isFromTata));
    },
    // action: {
    //   routeId: ROUTE.DIGIO_AGREEMENT_INPROGRESS,
    //   type: ACTION.INIT_DIGIO,
    //   payload: {}
    // },
    actions: {
        [ACTION.CALL_DIGIO_AGAIN]: initAction,
        // [ACTION.INIT_DIGIO]: initAction,
        [ACTION.FAILED_VERIFICATION]: failedVerification,
        [ACTION.SUCCESS_VERIFICATION]: successVerification,
    },
    clearPrevious: true,
};
